<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">WMMR / Monthly Membership Growth</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.members_at_the_beginning"
              label="No of at the beginning *"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.members_add"
              label="No. of add Members *"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.members_dropped"
              label="No. of dropped Members*"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.members_at_the_end"
              label="Members at the end *"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.transfer_members"
              label="Transferred Members"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Reporting date'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              filled
              prepend-icon="mdi-paperclip"
              outlined
              dense
              v-model="form.wmmr_report"
              label="Please attached WMMR report"
            ></v-file-input>
            <small>Max Size 500Kb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.members_at_the_beginning"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import DatePicker from "@/components/shared/DatePicker";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker },

  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      members_at_the_beginning: "",
      members_add: "",
      members_dropped: "",
      members_at_the_end: "",
      date: null,
      wmmr_report: null,
      transfer_members: 0,
    },
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("wmmr_report", this.form.wmmr_report);
      fd.append("venue", this.form.venue);
      fd.append("members_at_the_beginning", this.form.members_at_the_beginning);
      fd.append("members_add", this.form.members_add);
      fd.append("members_dropped", this.form.members_dropped);
      fd.append("members_at_the_end", this.form.members_at_the_end);
      fd.append("transfer_members", this.form.transfer_members);
      fd.append("date", this.form.date);
      fd.append("month", this.$route.params.month);
      fd.append("key", "MONTHLY_MEMBERSHIP");

      let data = fd;
      ActivityService.submitActivity("membership-growths", data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getDate(e) {
      console.log(e);
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
